import axiosInstance from '../axios/axiosInstance'
import { REACT_APP_AUTH_API_DEV } from '../utils/config'

// One weekly row of the scoreboard. Every figure is relative — an index, a
// percentage or a headcount. No absolute revenue crosses this API; see
// pythons/North-Star/build_page.py payload().
export interface NorthStarRow {
  week: string
  index: number
  wow: number | null
  trailing: number | null
  // null = that channel is UNKNOWN for that week (not tracked yet, or the
  // fetch failed). Never render it as zero — the two look identical stacked
  // and mean opposite things.
  band: Record<string, number | null>
  share: Record<string, number | null>
  contrib: Record<string, number | null>
}

export interface NorthStarChannelStat {
  known: boolean
  firstWeek?: string
  stale?: boolean
  asOf?: string
  share?: number
  index?: number | null
  wow?: number | null
  subs?: number | null
  weeks?: number
}

export interface NorthStarPayload {
  target: number
  trailing: number
  baseline: string
  metric: string
  company: string
  rows: NorthStarRow[]
  stats: {
    subs: number
    subsDelta: number | null
    // Set when a channel's newest figure is older than the newest week (Play
    // publishes a month's file days after it ends). The headcount still counts
    // that channel's last known figure, so the page must say how old it is —
    // otherwise the total silently mixes vintages.
    subsAsOf: string | null
    index: number
    wow: number | null
    trailing: number
    streak: number
    yoy: number | null
  }
  channelStats: Record<string, NorthStarChannelStat>
  mixStartIdx: number | null
  channels: { key: string; label: string; color: string }[]
  footer: string
}

export interface NorthStarSnapshot {
  available: boolean
  payload?: NorthStarPayload
  generated_at?: string
  latest_week?: string | null
}

export const getNorthStarSnapshot = async (): Promise<NorthStarSnapshot> => {
  const res = await axiosInstance.get(`${REACT_APP_AUTH_API_DEV}northstar`)
  return res?.data
}
